import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

export const resolve = (obj, path, defaultValue = null) => {
  if (!obj || !path) {
    return defaultValue;
  }

  const parts = path.split('.');

  return parts.reduce((newObj, part) => {
    if (!newObj) {
      return defaultValue;
    }

    if (newObj[part]) {
      newObj = newObj[part]; // eslint-disable-line
      return newObj;
    }

    return defaultValue;
  }, obj);
};

export const getViewportWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

export const getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

export const getScrollHeight = () =>
  Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );

export const openSocialPopup = url =>
  window.open(
    url,
    'fbShareWindow',
    `height=450, width=550, top=${getViewportHeight() / 2 - 275}, left=${getViewportWidth() / 2 -
      225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`
  );

export const bodyNoScroll = {
  scrollTop: 0,
  add(breakpoint) {
    this.breakpoint = breakpoint;

    if (!breakpoint || getViewportWidth() < breakpoint) {
      this.scrollTop = window.scrollY;
      document.documentElement.classList.add('lock-scroll');

      if (typeof window.bb !== 'undefined') {
        try {
          window.bb.header.headroom.destroy();
        } catch (e) {}
      }
    }
  },
  remove() {
    document.documentElement.classList.remove('lock-scroll');
    window.scrollTo(0, this.scrollTop);

    if (typeof window.bb !== 'undefined') {
      window.bb.header.init();
    }
  },
};

export const getUserAgent = () => navigator.userAgent || navigator.vendor || window.opera;

export const isAndroid = () => {
  const userAgent = getUserAgent();

  return /android/i.test(userAgent);
};

export const isIOS = () => {
  const userAgent = getUserAgent();

  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export const isAndroidOrIOS = () => isAndroid() || isIOS();

export const stripHtmlTags = html => new DOMParser().parseFromString(html, 'text/html').body.textContent;

export const getLanguageCode = () => {
  const languageCode = document.documentElement.lang || 'en-GB';

  if (languageCode == 'en') return 'en-GB';

  return languageCode;
};

export const getTwoLetterIsoName = () => getLanguageCode().split('-')[1];

export const getTwoLetterIsoLanguageName = () => getLanguageCode().split('-')[0];

export const pluraliseEn = (string, count) => (count === 1 ? string : `${string}s`);

export const formatFittingTime = fittingTime => {
  const languageCode = getLanguageCode();

  return moment.duration(fittingTime, 'minutes').format('m _', {
    userLocale: languageCode,
  });
};

export const interceptLinkClick = (event, callback) => {
  event.preventDefault();

  callback();

  const link = event.target.closest('a');
  if (link.target === '_blank') {
    window.open(link.href);
  } else {
    window.location.href = link.href;
  }
};

export const getContentBasePath = () => {
  const rootEl = document.getElementById('configurator-root');
  const contentApiEndpoint = rootEl.dataset.apiEntrypoint;

  return contentApiEndpoint;
};

export const truncateString = (str, length = 35, delim = ' ', ellipses = '...') => {
  if (str.length <= length) {
    return str;
  }

  let trimmedStr = str.substr(0, length + delim.length);

  const lastDelimIndex = trimmedStr.lastIndexOf(delim);

  if (lastDelimIndex >= 0) {
    trimmedStr = trimmedStr.substr(0, lastDelimIndex);
  }

  if (trimmedStr) {
    trimmedStr += ellipses;
  }
  return trimmedStr;
};

export const roundPrecisionDecimal = decimal => Number(decimal.toFixed(2));

export const isIE = () => Boolean(window.document.documentMode);

export const isEdge = () => window.navigator.userAgent.toLowerCase().indexOf('edge') > -1;

export const isWindows = navigator.appVersion.indexOf('Win') !== -1;

export const getFromDataLayer = property =>
  window.dataLayer.reduceRight((value, event) => value || event[property], null);

export const updateLinkSubmit = ({ link, productCode, colourCode, configurationID, configurationUrl }) => {
  if (!link) return link;
  return link
    .replace('{productCode}', productCode || '')
    .replace('{colourCode}', colourCode || '')
    .replace(configurationID && '{configurationID}', configurationID)
    .replace(configurationUrl && '{configurationUrl}', configurationUrl ? btoa(configurationUrl) : null);
};

export const removeDuplicateParams = (url, paramsToRemove) => {
  try {
    const urlObj = new URL(url, window.location.origin);
    const searchParams = new URLSearchParams(urlObj.search);

    paramsToRemove.forEach(param => {
      if (searchParams.has(param)) {
        const values = searchParams.getAll(param);
        searchParams.delete(param);
        if (values.length > 0) {
          searchParams.set(param, values[0]);
        }
      }
    });

    let newUrl = urlObj.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');

    newUrl = newUrl
      .replace(/\?{2,}/g, '?')
      .replace(/&&+/g, '&')
      .replace(/\?&/g, '?')
      .replace(/&$/, '');

    return newUrl;
  } catch (error) {
    console.error('Erro to process URL:', error);
    return url;
  }
};
